// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e99238b7","639":"9164aaf8"}[chunkId] + ".chunk.js";
};